import { render, staticRenderFns } from "./videoDashboard.vue?vue&type=template&id=2af0a564&scoped=true"
import script from "./videoDashboard.vue?vue&type=script&lang=js"
export * from "./videoDashboard.vue?vue&type=script&lang=js"
import style0 from "./videoDashboard.vue?vue&type=style&index=0&id=2af0a564&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af0a564",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af0a564')) {
      api.createRecord('2af0a564', component.options)
    } else {
      api.reload('2af0a564', component.options)
    }
    module.hot.accept("./videoDashboard.vue?vue&type=template&id=2af0a564&scoped=true", function () {
      api.rerender('2af0a564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/videoDashboard.vue"
export default component.exports